import {
    AsGrid,
    AsSearchBar,
    mapPageInfo,
    Modal,
} from '@adserve/adserve-react-components';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { apiParamsReducer, defaultPageInfo } from '../../../services/AsGridService';
import CreatePackageOrders from './CreatePackageOrders';
import AddPackageDialog from './AddPackageDialog';
import {
    CreateOrUpdateCampaignPackage,
    DeleteCampaignPackage,
    ListCampaignPackages,
    GetPackages,
    GetReservationTimes
} from '../../../services/DataService';

import { tableAreaStyle } from '../../../styles';
import { gridItemStyle, sectionedPanelStyle } from '../CampaignStyles';
import { getPackageColumnDefinitions } from './PackageColumnDefinitions';
import CampaignPackagesPanel from './CampaignPackagesPanel';

const PackagePanel = ({ campaign, onSelectPackage }) => {
    const [packages, setPackages] = useState([]);
    const canLoad = true;
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [reservationTimes, setReservationTimes] = useState([]);
    const { dateFormat, timeFormat, locale, currency } = useContext(SystemSettingsContext);
    const apiParamDefaults = {
        sortField: 'name',
        sortOrder: 'asc',
        pageNumber: 1,
        pageSize: 15,
        reservations: false,
        stationIds: []
    };

    const [apiParams, apiParamsDispatcher] = useReducer(apiParamsReducer, apiParamDefaults);

    const [columnDefinitions, setColumnDefinitions] = useState(getPackageColumnDefinitions());

    const loadReservationTimes = () => {
        GetReservationTimes({ pageNumber: 1, pageSize: -1 }).then((res) => {
            setReservationTimes(res.data);
        });
    };
    const getCampaignPackages = async () => {
        await ListCampaignPackages(campaign.id).then((data) => {
            data.map((a, b) => {
                a.numWeeks = a.weeks.length;
                a.numStations = a.stations.length;
                a.price = a.weeks.length * a.oneWeekPrice;
            });
            campaign.campaignPackages = data;
            setCampaignPackageData(campaign.campaignPackages);
        });
    };

    useEffect(() => {
        if (canLoad) {
            loadData();
        }
    }, [apiParams]);

    const loadData = () => {
        GetPackages({
            ...apiParams,
            startDate: campaign?.startDate,
            endDate: campaign?.endDate
        }).then((data) => {
            setPackages(data.data);
            setPageInfo(mapPageInfo(data));
        });
    };

    const handleSearchUpdate = (value) => {
        apiParamsDispatcher({ searchTerm: value });
    };

    const handlePageSizeChange = (option) => {
        apiParamsDispatcher({ pageSize: option.value, pageNumber: 1 });
    };

    const handleNextClick = () => {
        const newPageNumber = apiParams.pageNumber + 1;
        if (newPageNumber <= pageInfo.pageCount) {
            apiParamsDispatcher({ ...apiParams, pageNumber: newPageNumber });
        }
    };

    const handlePrevClick = () => {
        const newPageNumber = apiParams.pageNumber - 1;
        if (newPageNumber >= 1) {
            apiParamsDispatcher({ ...apiParams, pageNumber: newPageNumber });
        }
    };

    const handleSortOrderChange = (column) => {
        const unchangedColumns = columnDefinitions
            .filter((c) => c.field !== column.field)
            .map((c) => ({ ...c, sortOrder: '' }));

        const sortField = column.field === 'status' ? 'statusEnumOrder' : column.field;

        setColumnDefinitions([...unchangedColumns, column]);
        apiParamsDispatcher({
            sortField: sortField,
            sortOrder: column.sortOrder
        });
    };

    const handlePrimaryColumnClick = (show) => {
        goAdd(show);
    };

    const [selectedPackage, setSelectedPackage] = useState();
    const [addingPackage, setAddingPackage] = useState(false);

    const [campaignPackageData, setCampaignPackageData] = useState([]);
    const [selectedCampaignPackage, setSelectedCampaignPackage] = useState();

    const loadPackages = (apiParams) => {
        loadData();
    };

    useEffect(() => {
        loadPackages();
        loadReservationTimes();
        getCampaignPackages();
    }, [campaign?.id]);
    const handleActionClick = (a, b) => {
        console.log('action', a, b);
    };
    const goAdd = (a) => {
        setSelectedCampaignPackage({ id: window.newGuid(), packageId: a.id });
        setSelectedPackage(a);
        setAddingPackage(true);
    };

    const addPackage = (pack) => {
        setAddingPackage(false);
        if (!campaign.campaignPackages) campaign.campaignPackages = [];

        CreateOrUpdateCampaignPackage(pack).then(() => {
            ListCampaignPackages(campaign.id).then((data) => {
                data.map((a, b) => {
                    a.numWeeks = a.weeks.length;
                    a.numStations = a.stations.length;
                    a.price = a.weeks.length * a.oneWeekPrice;
                });
                campaign.campaignPackages = data;
                setCampaignPackageData(campaign.campaignPackages);
                setSelectedPackage({});
                setIsQuoting(true);
            });
        });
    };

    const deletePackage = (id) => {
        DeleteCampaignPackage(id).then(() => {
            getCampaignPackages();
        });

        setSelectedCampaignPackage({});
    };

    const handleIconDisabilty = (actionType, status, mutar) => {
        return false;
    };
    const [isQuoting, setIsQuoting] = useState(false);

    return (
        <>
            {isQuoting && <CreatePackageOrders campaign={campaign} done={() => setIsQuoting(false)} />}
            {addingPackage && (
                <Modal
                    isShowing={addingPackage}
                    hide={() => setAddingPackage(false)}
                    style={{
                        width: 1200 + (selectedPackage?.weeks?.length > 20 ? 400 : 0),
                        height: 300 + selectedPackage?.weeks?.length * 15
                    }}
                >
                    <AddPackageDialog
                        cancelPackage={() => setAddingPackage(false)}
                        campaignPackage={selectedCampaignPackage}
                        pack={selectedPackage}
                        campaign={campaign}
                        addPackageCallBack={addPackage}
                        reservationTimes={reservationTimes}
                    />
                </Modal>
            )}
            <div
                style={{
                    ...sectionedPanelStyle,

                    marginLeft: 30,
                    marginTop: 0,
                    padding: '10px 40px 40px'
                }}
            >
                <CampaignPackagesPanel
                    campaign={campaign}
                    campaignPackageData={campaignPackageData}
                    onReserveProperty={() => {}}
                    onDeletePackage={deletePackage}
                    readOnly={false}
                ></CampaignPackagesPanel>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        position: 'relative',
                        top: -186,
                        height: 5
                    }}
                >
                    <div style={{ ...gridItemStyle }}>
                        <AsSearchBar
                            id='showSearch'
                            placeholder={window.translate(apiParams.reservations ? 'Search Shows...' : 'Search...')}
                            width={395}
                            height={42}
                            currentSearchTerm={apiParams.searchTerm}
                            onSearchUpdate={handleSearchUpdate}
                        />
                    </div>
                </div>
                <div style={{ ...gridItemStyle, ...tableAreaStyle, paddingLeft: 60, paddingRight: 40 }}>
                    <AsGrid
                        style={{
                            borderLeft: '1px solid rgb(215, 215, 215)'
                        }}
                        columnDefs={columnDefinitions}
                        pageInfo={pageInfo}
                        data={packages}
                        primaryColumn='name'
                        onPageSizeChange={handlePageSizeChange}
                        onNextClick={handleNextClick}
                        onPrevClick={handlePrevClick}
                        onSortOrderChange={handleSortOrderChange}
                        onPrimaryColumnClick={handlePrimaryColumnClick}
                        showColumnFilter={false}
                        dateFormat={dateFormat}
                        timeFormat={timeFormat}
                        onActionIconLoad={handleIconDisabilty}
                        onActionClick={handleActionClick}
                        locale={locale}
                        currency={currency}
                    />
                </div>
            </div>
        </>
    );
};

export default PackagePanel;
